import { styled } from '@mui/material';
import FlexBetween from 'components/flexbox/FlexBetween';
import SearchInput from 'components/input-fields/SearchInput';
const SecondaryWrapper = styled(FlexBetween)(({ theme }) => ({
    gap: 8,
    maxWidth: '100%',
    width: '100vw',
    justifyContent: 'center',
})); // --------------------------------------------------------------------

// --------------------------------------------------------------------
const SearchArea = ({ value, onChange, setValue, onEnter }) => {
    return (
        <SecondaryWrapper>
            <SearchInput
                placeholder="Please Scan Your QR Code..."
                value={value || ''}
                onChange={(e) => {
                    if (onChange && setValue) {
                        setValue(e.target.value);
                        onChange(e.target.value);
                    }
                    onChange(e.target.value);
                }}
                onEnter={onEnter}
            />
        </SecondaryWrapper>
    );
};

export default SearchArea;
